import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {CabinetResponse} from "../types/cabinet";

export const fetchCabinetData = createAsyncThunk<CabinetResponse>(
    'cabinet/fetchCabinetData',
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<CabinetResponse>('/api/profile/cabinet', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error) {
            console.error(error);
            return thunkAPI.rejectWithValue('error');
        }
    }
);
